import React from 'react';
import {Await, useLoaderData, useMatches} from '@remix-run/react';
import {Suspense} from 'react';

//components
import ProductsMarquee from 'components/modules/ProductsMarquee';

//types
import type {I18nLocale} from '~/lib/type';

import {loader} from '~/routes/($lang)/index';

/**
 * Homepage "新到產品 / New Arrivals" section: the 10 most recently listed
 * products, queried live from Shopify by CREATED_AT (newest first) — a real
 * new-arrivals feed, distinct from the curated 店長推薦 marquee above it.
 * Deferred so it never blocks the homepage's first paint.
 */
const NewArrivals: React.FC = () => {
  const {newArrivals} = useLoaderData<typeof loader>();
  const [root] = useMatches();
  const selectedLocale = root?.data?.selectedLocale as I18nLocale | undefined;
  const isZh = selectedLocale?.language !== 'EN';

  if (!newArrivals) return <></>;

  return (
    <Suspense fallback={null}>
      <Await resolve={newArrivals}>
        {(products) => {
          if (!products || products.length === 0) return <></>;
          return (
            <ProductsMarquee
              title={isZh ? '新到產品' : 'New Arrivals'}
              products={products}
              className="!pb-2"
              // New arrivals that are out of stock read 即將到貨, not 缺貨.
              comingSoon
            />
          );
        }}
      </Await>
    </Suspense>
  );
};

export default NewArrivals;
